import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, Button } from 'reactstrap';

import './dealer-fees-modal.scss';

export function DealerFeesModal({ isOpen = false, toggle, renderContent }) {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered modalClassName="dealer-fees-modal">
      <ModalBody className="p-1_5 bg-cool-gray-90 border-radius-1">
        <div className="d-flex justify-content-between align-items-center mb-1">
          <h2 className="mb-0 heading-4">Price Details</h2>
          <Button
            color="link"
            onClick={toggle}
            aria-label="Close price details"
            className="close-button pos-a right-0 p-0 text-white size-24"
          >
            <span className="icon-cross2" aria-hidden />
          </Button>
        </div>
        {renderContent()}
      </ModalBody>
    </Modal>
  );
}

DealerFeesModal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func.isRequired,
  renderContent: PropTypes.func.isRequired,
};
